import React from "react";
import "./App.css";
import "./Components/common_components/common_css/Common_Css.css";

import All_Routes from "./Components/All_Routes/All_Routes";
import Footer from "./Components/Footer/Footer";
import Header from "./Components/Header/Header";
import ScrollToTop from "./Components/CommonPage/ScrollToTop/ScrollToTop";
import AppContext from "./utils/context";

function App() {
  return (
    <>
      <AppContext>
        <div className="flex-wrapper">
          <Header />
          <div>
            <ScrollToTop />
            <All_Routes />
          </div>
          <Footer />
        </div>
      </AppContext>
    </>
  );
}

export default App;
